import { Radio as AntRadio } from "antd";

const RadioButton = AntRadio.Button;

export default RadioButton;
